import { useAuth0 } from '@auth0/auth0-react';
import { decodeJwt, type JWTPayload } from 'jose';
import { useEffect, useState } from 'react';
import { AUTH_BYPASS_ENABLED } from '~/lib/dev-auth-bypass.constants';

export enum AuthPermission {
  operator = 'operator',
  admin = 'admin',
  superAdmin = 'superAdmin',
}
export type AuthToken = JWTPayload & { org_id: string; permissions: AuthPermission[] };

const BYPASS_TOKEN: AuthToken = {
  org_id: 'local-dev-org',
  permissions: [AuthPermission.operator, AuthPermission.admin, AuthPermission.superAdmin],
};

export function useAuthToken() {
  const [token, setToken] = useState<AuthToken | null>(AUTH_BYPASS_ENABLED ? BYPASS_TOKEN : null);
  const { getAccessTokenSilently, isAuthenticated, isLoading: auth0Loading } = useAuth0();

  useEffect(() => {
    if (AUTH_BYPASS_ENABLED) {
      return;
    }

    let isMounted = true;

    const fetchToken = async () => {
      try {
        const claims = await getAccessTokenSilently();

        if (isMounted) {
          const decoded = decodeJwt<AuthToken>(claims);
          setToken(decoded);
        }
      } catch (error) {
        console.warn('Failed to get access token:', error);
        if (isMounted) {
          setToken(null);
        }
      }
    };

    fetchToken();

    return () => {
      isMounted = false;
    };
  }, [getAccessTokenSilently, isAuthenticated, auth0Loading]);

  return token;
}
